/*
 * @Author: your name
 * @Date: 2021-04-28 13:22:03
 * @LastEditTime: 2021-05-20 14:18:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/system.config.js
 */
// 系统配置/运营中心
export default {
  // 权限组 - 批量新增组织（relateType=1，与用户共用选择弹窗）
  BATCH_INSERT_ORG: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/BATCH_INSERT_USER.vue'
    ),
  },
  // 权限组 - 批量新增用户（relateType=2）
  BATCH_INSERT_USER: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/BATCH_INSERT_USER.vue'
    ),
  },
  MODIFY_ENV: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/MODIFY_ENV.vue'
    ),
  },

  // 运营中心
  MANUALMATCHINGRODUCTYNC: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/MANUALMATCHINGRODUCTYNC.vue'
    ),
  },
  BATCHUPDATESRODUCTYNC: {
    component: () => import(
      /* webpackChunkName: 'SystemConfigModal' */
      '@/views/modal/systemConfig/BATCHUPDATESRODUCTYNC.vue'
    ),
  },
};
